export default __webpack_public_path__ + "static/media/courselearn.9c2426e4.png";